/* eslint-disable react-hooks/exhaustive-deps */

import { useSelector } from 'react-redux';

import { selectShowCredentialForm } from '../../selectors';

const useCredentialForm = () => {
  const showCredentialForm = useSelector(selectShowCredentialForm);

  return {
    showCredentialForm,
  };
};

export default useCredentialForm;
